<template>
  <Teleport to="#main-header">
    <div :style="{ paddingBottom: '87px' }">
      <div class="ask_ai position-fixed w-100" :style="{ top: headerHeightVal + 'px' }" style="z-index: 98;"
        :class="{ 'is_gradient': isGradient }">
        <div v-if="showChatData" class="overlay_section" @click="hideAiwidget()"></div>
        <div class="assistant_card_strip">
          <transition name="bar-slide" @after-leave="showWindow = true">
            <div class="bg-white custom_box_shadow position-relative" v-if="showBar" style="z-index: 98">
              <div class="container">
                <div class="d-flex align-items-center row" @click="openchatwidget();">
                  <div class="flex-1">
                    <div class="d-flex align-items-center">
                      <AssistantIcon :chat-theme-settings="chatThemeSettings" />
                      <div class="py-4 pl-3"
                        placeholder="How can we help you today? For example, can I get a price on a new Honda Accord?">
                        <p class="m-0 font-weight-bold strip_input">{{ stripInput }}
                        </p>
                      </div>
                    </div>


                  </div>
                  <div>
                    <div class="d-flex align-items-center gap-lg-1">
                      <div>
                        <MicrophoneIcon />
                      </div>
                      <div>
                        <!-- <span class="border_horizontal"></span> -->
                      </div>
                      <div>
                        <!-- <AssistantIcon /> -->
                        <div class="arrow_down cursor_pointer"
                          :style="{ background: themePrimaryColor, color: '#fff' }">
                          <em class="primaryicon-longarrow-right" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </transition>
          <transition name="window-slide" @after-enter="showInput = true" @after-leave="showBar = true">
            <div v-if="showChatData && showWindow" class="expandable-content" :style="setBackgroudColor">
              <div class="d-flex justify-content-end mt-2  rounded-circle position-absolute close_icon_container"
                :class="isGradient ? 'transparent-bg' : 'bg-white custom_box_shadow'">
                <div class="primary-close-circle_icon cursor-pointer " @click="hideAiwidget()">
                  <em class="primaryicon-times " :class="{ 'gradient_text_white': isGradient }"></em>
                </div>
              </div>

              <div class=" flex-1 conversation_container" id="chat__bodyview">
                <div class="col-md-12">
                  <div class="pt-5 px-lg-4">
                    <div v-for="(item, index) in fullfillmenttextList" :key="index">
                      <UserQuestion v-if="item.request?.UserResponse" :userinput="item.request" :design="designId"
                        :requesttime="item.requestTime" :index="index" :initial-name="item.initials"
                        :chat-theme-settings="chatThemeSettings" />
                      <UserQuestion v-else-if="item.request?.EventLabel" :userinput="item.request" :design="designId"
                        :requesttime="item.requestTime" :index="index" :initial-name="item.initials"
                        :chat-theme-settings="chatThemeSettings" />


                      <ai-full-fill-ment-text v-if="item && item.responseData" :request="item.request" :item-data="item"
                        @tvm-suggestions="tvmSuggestions" @tvm-structured-suggestions="tvmSuggestions"
                        :design="designId" :user-input-text="userInput"
                        :selected-auto-completed-value="selectedAutoCompletedValue"
                        @selectedInputAddress="selectedInputAddress" @selectedInputYmmt="selectedInputYmmt"
                        :response-data="item.responseData" :chat-theme-settings="chatThemeSettings"
                        :response-time="item.responseTime" :is-last-index="fullfillmenttextList.length
                          ? fullfillmenttextList.length - 1 === index
                          : false
                          " :full-fill-ment-text="item.fullfillmentText">
                      </ai-full-fill-ment-text>
                    </div>

                    <tvm-pre-loader :chat-theme-settings="chatThemeSettings"
                      v-if="chatResponseDelayLoading || isLoader" />


                  </div>
                </div>
              </div>
              <transition name="input-slide">
                <div v-if="showInput">
                  <div class="px-4 d-flex mx-lg-5 mt-2">
                    <div class="mt-3">
                      <Sparks fHeight="55" width="65" />
                      <!-- <AssistantWithSpark :height="65" :width="65" :is-gradient="isGradient" /> -->
                    </div>
                    <div class="flex-1 ml-2">
                      <div class="d-flex align-items-center px-3 chat_input_container" :disabled="disable ||
                        disableChat ||
                        isWaitingForResponse ||
                        fullfillmenttextList.length === 0">
                        <div class="flex-1">
                          <input rows="2" id="MessageContainer" @focus="clearPropmpts()"
                            :placeholder="disableText ? disableText : placeHolderText ? placeHolderText : 'Type your message...'"
                            autocomplete="off" @keyup.enter="sendMessage()" v-model="userInput" :disabled="disable ||
                              disableChat ||
                              isWaitingForResponse ||
                              fullfillmenttextList.length === 0
                              " class="form-control shadow-none border-0 bg-transparent" type="text"
                            placeholder="How can we help you today? For example, can I get a price on a new Honda Accord?">

                        </div>
                        <div>
                          <div class="d-flex align-items-center  send_container">
                            <!-- <div class="cursor_pointer" @click="speechToText()">
                          <div class="pulse-container" :class="{ 'pulse': isListening }">
                            <MicrophoneIcon />
                          </div>
                        </div> -->
                            <VoiceRecorder @voice-message="voiceMessage($event)"
                              @voice-message-text="voiceMessageText($event)" />
                            <div @click="sendMessage"
                              class="send_icon d-flex align-items-center justify-content-center cursor_pointer"
                              :style="{ background: themePrimaryColor }">
                              <em class="primaryicon-longarrow-right"></em>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center gap-lg-1 mb-2">
                        <div class="d-flex align-items-center    rounded-buttons btn cursor-pointer footer_icon"
                          :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }" @click="
                            startMainMenu($event);" @mouseover="isHoverMenu = true" @mouseleave="isHoverMenu = false">
                          <menu-icon :theme-color="isGradient ? '#fff' : '#B3B3B3'" :is-hover-menu="isHoverMenu"
                            height="18px" width="20px" />
                          <span class="pl-2" :class="[isGradient ? 'text-white hover_black' : 'text-black']">Menu</span>
                        </div>
                        <div @click="showHoursModal()"
                          class="d-flex align-items-center  rounded-buttons btn cursor-pointer footer_icon"
                          :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }"
                          @mouseover="isHoverHour = true" @mouseleave="isHoverHour = false">
                          <hours-icon :theme-color="isGradient ? '#fff' : '#B3B3B3'" :is-hover-hour="isHoverHour"
                            height="18px" width="20px" />
                          <span class="pl-1"
                            :class="[isGradient ? 'text-white hover_black' : 'text-black']">Hours</span>
                        </div>

                        <div class="d-flex align-items-center    rounded-buttons btn  cursor-pointer footer_icon"
                          :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }"
                          v-if="enableTranslationIcon" @click="languageChangeEvent()"
                          @mouseover="isHoverLanguage = true" @mouseleave="isHoverLanguage = false">
                          <language-change-icon :icon-plus-text="true">
                            <template #iconPlusText="slotProps">
                              <div class="d-flex align-items-center">
                                <language-icon :theme-color="isGradient ? '#fff' : '#B3B3B3'"
                                  :is-hover-language="isHoverLanguage" height="18px" width="20px" />
                                <span ref="languageRefContent" class="m-0 pl-2"
                                  :class="[isGradient ? 'text-white hover_black' : 'text-black']">{{ slotProps.text
                                  }}</span>
                              </div>

                            </template>
                          </language-change-icon>
                        </div>
                        <div class="d-flex align-items-center   rounded-buttons btn cursor-pointer footer_icon"
                          :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }" v-if="!disableSignIn"
                          @click="LogoutUser($event)" @mouseover="isHoverUser = true" @mouseleave="isHoverUser = false">
                          <sign-in-icon :theme-color="isGradient ? '#fff' : '#B3B3B3'" :is-hover-user="isHoverUser"
                            height="18px" width="20px" />
                          <span class="pl-1" :class="[isGradient ? 'text-white hover_black' : 'text-black']"> {{
                            isAuthenticated ===
                              "True" ? "Sign Out" :
                              "Sign In" }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </transition>



              <div v-if="showModal">
                <Teleport to="body">
                  <div id="viewDetailsModal" class="modal" :style="{ display: showModal ? 'block' : 'none' }">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <!-- Modal Header -->
                        <div class="modal-header align-items-center">
                          <h6 class="m-0 _theme_font_bold">Hours</h6>
                          <div>
                            <button type="button" aria-label="Close" class="close" @click.prevent="showModal = false">
                              ×
                            </button>
                          </div>
                        </div>
                        <div class="p-3">
                          <DealerWorkingHours />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-backdrop show" />
                </Teleport>
              </div>
              <tvm-loader-modal v-if="isSignInNavigationModal" message="Logging you in. Please wait..." />
              <tvm-loader-modal v-if="isSignOut" message="Logging you out. Please wait..." />
              <tvm-loader-modal v-if="isTranslationChange" message="Translating content. Please wait..." />

            </div>
          </transition>
        </div>
        <div v-if="showchat && !ismobile && !isChatOpenInModal" id="chat_button_enabled" class="d-none">
          <chat-assistant @openAssistant="openAssistant($event)" @openService="openService($event)"
            @tileNavigate="assistantParamsDataModal($event)" @modalNavigate="modalNavigate($event)"
            @disableWebBackgroundBlur="disableWebBackgroundBlur($event)"
            @assistantSettingsData="assistantSettingsData($event)" />
        </div>
      </div>

    </div>

  </Teleport>
</template>

<script>


import UserQuestion from "./Aicomponents/UserQuestion.vue";
import { mapWritableState } from 'pinia';
// import { useConversationStore } from "../../store/AiConversationStore/AiConversationStore";
import AssistantIcon from "./icons/AssistantIcon.vue";
// import MicroPhone from "./icons/MicroPhone.vue";
import chatwidget from "../ChatWidget/ChatWidget.js";
import { ChatWidgetService } from "../../../Services/ChatWidgetService/ChatWidgetService.js";
import AiFullFillMentText from "./AiComponents/AiFullFillMentText.vue";
import TvmPreLoader from "../TvmPreLoader/TvmPreLoader.vue";
import { useChatSettingsStore } from '../../../store/ChatSettingsStore/ChatSettingsStore.js';
import AiHoursModal from "./AiComponents/AiHoursModal.vue";
import DealerWorkingHours from "../DealerWorkingHours/DealerWorkingHours.vue";
// import MicroPhone from "./icons/MicroPhone.vue";
import MicrophoneIcon from "../ChatIcons/MicrophoneIcon.vue";
import { getAiPrompts } from "./config/AiPrompts.js";
import { ref } from "vue";
import AssistantWithSpark from "./Icons/AssistantWithSpark.vue";
import eventBus from '../../../Services/EmitterService/EmitterService';
import { generateGradient, getheaderHeight } from "../../../../../js/services/CommonUtility.js";
import VoiceRecorder from "./AiComponents/VoiceRecorder.vue";
import Sparks from './Icons/Sparks.vue';




export default {
  mixins: [chatwidget],
  data() {
    return {
      isExpanded: false,
      messageInput: '',
      sessionID: null,
      showModal: false,
      designId: null,
      isListening: false,
      recognition: null,
      showInput: false,
      showWindow: false,
      userInput: '',
      predefinedPrompt: 'How can we help you today?',
      typingIndex: 0,
      typingInterval: null,
      prompts: [],
      currentPromptIndex: 0,
      currentWordIndex: 0,
      words: [],
      inputRef: ref(null),
      stripTypingInterval: null,
      stripInput: '',
      isSpeaking: false,
      primaryColor: window.primaryColor,
      placeHolderText: null,
      headerHeightVal: getheaderHeight(),
    };
  },
  created() {
    this.sessionID = sessionStorage.getItem("sessionID") || this.generateSessionID();
    sessionStorage.setItem("sessionID", this.sessionID);
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
    setBackgroudColor() {
      if (this.aiThemeBg === 'oem' || this.aiThemeBg?.includes('#')) {
        return { background: generateGradient(this.aiThemeBgColor) };
      } else if (this.aiThemeBg === 'grey') {
        return { background: '#f9f9f9' };
      } else {
        return { background: this.aiThemeBg };
      }
    },
    aiThemeBg() {
      return this.chatThemeSettings?.aiThemeBg;
    },
    isGradient() {
      return this.chatThemeSettings?.aiThemeBg === 'oem' || this.chatThemeSettings?.aiThemeBg?.includes('#');
    },
    aiThemeBgColor() {
      return this.chatThemeSettings?.aiThemeBgColor;
    },
    themePrimaryColor() {
      return this.chatThemeSettings?.primeColor || this.primaryColor;
    }
  },
  methods: {
    sendMessageValue() {
      this.sendMessage();
      if (this.recognition && this.isListening) {
        this.recognition.stop();
        this.isListening = false;
        this.isSpeaking = false;
        console.log('Speech recognition stopped.');
        return;
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.openAssistant();
        let cookieId = ChatWidgetService.getChatSessionCookie();
        let oldsid = sessionStorage.getItem('oldsid');
        if (oldsid && cookieId && oldsid !== cookieId) {
          this.loadChatWithSessionData(cookieId, oldsid);
        } else {
          this.loadChatWithSessionData(cookieId, null);
        }
      } else {
        this.showChatData = false;
      }
    },
    // sendMessage() {
    //   if (this.messageInput.trim()) {
    //     try {
    //       const conversationStore = useConversationStore();
    //       let request = {
    //         UserResponse: this.messageInput,
    //       };
    //       conversationStore.sendMessage(request);
    //       console.log(conversationStore, 'conversationStore')
    //       this.messageInput = '';
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   }
    // },
    hideAiwidget() {
      this.showInput = false
      setTimeout(() => {
        this.showWindow = false;
        this.hidewidget();
      }, 300);
    },
    generateSessionID(length = 50) {
      const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let sessionID = "";
      for (let i = 0; i < length; i++) {
        sessionID += charset.charAt(Math.floor(Math.random() * charset.length));
      }
      return sessionID;
    },
    showHoursModal() {
      this.showModal = true;
    },
    startSpeechToText() {
      this.userInput = '';
      this.isSpeaking = false;
      if (!('webkitSpeechRecognition' in window)) {
        alert('Speech recognition is not supported in this browser.');
        return;
      }

      if (this.recognition && this.isListening) {
        this.recognition.stop();
        this.isListening = false;
        this.isSpeaking = false;
        console.log('Speech recognition stopped.');
        return;
      }

      this.recognition = new webkitSpeechRecognition();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = true;
      this.recognition.maxAlternatives = 1;
      this.recognition.continuous = false;

      this.recognition.onstart = () => {
        this.isListening = true;
        this.isSpeaking = false;
        console.log('Speech recognition started...');
      };

      this.recognition.onresult = (event) => {
        // const transcript = event.results[0][0].transcript;

        let interimTranscript = '';
        let finalTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          const transcript = event.results[i][0].transcript;
          console.log(event.results, 'event.results')
          if (event.results[i].isFinal) {
            finalTranscript += transcript + ' ';
            this.userInput = finalTranscript.trim();
            this.sendMessage();
          }
        }

        this.userInput = finalTranscript + interimTranscript;;
        this.isSpeaking = false;
        this.isListening = false;
        // console.log('Recognized text:', transcript);
        this.sendMessage();
      };

      this.recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
      };

      this.recognition.onend = () => {
        console.log('Speech recognition ended.');
        this.isSpeaking = false;
        if (this.isListening && this.recognition.continuous) {
          this.recognition.start(); // Restart on end to support long speech
        }
        this.isListening = false;
      };

      this.recognition.start();
    },
    speechToText() {
      this.userInput = '';
      this.isSpeaking = false;

      if (!('webkitSpeechRecognition' in window)) {
        alert('Speech recognition is not supported in this browser.');
        return;
      }

      if (this.recognition && this.isListening) {
        this.recognition.stop();
        this.isListening = false;
        this.isSpeaking = false;
        console.log('Speech recognition stopped.');
        return;
      }

      this.recognition = new webkitSpeechRecognition();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;
      this.recognition.continuous = false; // We keep it false as requested

      let accumulatedTranscript = '';

      this.recognition.onstart = () => {
        this.isListening = true;
        this.isSpeaking = false;
        console.log('Speech recognition started...');
      };

      this.recognition.onresult = (event) => {
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            accumulatedTranscript += transcript + ' ';
          } else {
            interimTranscript += transcript;
          }
        }

        this.userInput = accumulatedTranscript + interimTranscript;
      };

      this.recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
      };

      this.recognition.onend = () => {
        console.log('Speech recognition ended.');
        this.isSpeaking = false;

        // Simulate long speech capture by restarting, unless user stopped it
        if (this.isListening) {
          console.log('Restarting recognition...');
          this.recognition.start();
          setTimeout(() => {
            this.sendMessageValue();
          }, 3000);
        } else {
          this.sendMessageValue();
        }
      };

      this.recognition.start();
    },
    prepareNextPrompt() {
      if (this.currentPromptIndex < this.prompts.length) {
        this.placeHolderText = '';
        this.words = this.prompts[this.currentPromptIndex].split(' ');
        this.currentWordIndex = 0;
      }
    },
    startTypingEffect() {
      this.typingInterval = setInterval(() => {
        if (this.currentWordIndex < this.words.length) {
          this.placeHolderText += this.words[this.currentWordIndex] + ' ';
          this.currentWordIndex++;
        } else {
          clearInterval(this.typingInterval);
          this.placeHolderText = '';
          setTimeout(() => {
            this.currentPromptIndex++;
            if (this.currentPromptIndex < this.prompts.length) {
              this.prepareNextPrompt();
              this.startTypingEffect();
            }
          }, 1000);
        }
      }, 150);
    },
    StripTypingEffect() {
      this.stripTypingInterval = setInterval(() => {
        if (this.typingIndex < this.predefinedPrompt.length) {
          this.stripInput += this.predefinedPrompt[this.typingIndex];
          this.typingIndex++;
        } else {
          clearInterval(this.stripTypingInterval);
        }
      }, 150);
    },
    clearPropmpts() {
      if (this.words.length > 0) {
        setTimeout(() => {
          clearInterval(this.typingInterval);
          this.words = [];
          this.placeHolderText = '';
        }, 100);
      }

    },
    voiceMessage(val) {
      if (val && val.trim() !== '') {
        this.userInput = val;
        this.sendMessage();
      }
    },
    voiceMessageText(val) {
      if (val && val.trim() !== '') {
        this.userInput = val;
      }
    },


    //

  },
  mounted() {
    this.StripTypingEffect();
    this.prompts = getAiPrompts().map(p => p.prompt);
    eventBus.$on('hidePrompts', (response) => {
      if (response) {
        this.clearPropmpts();
        if (document.getElementById('MessageContainer')) {
          document.getElementById('MessageContainer').focus();
        }
      }
    });
  },
  updated() {

  },
  components: {
    UserQuestion,
    AssistantIcon,
    // MicroPhone,
    AiFullFillMentText,
    TvmPreLoader,
    AiHoursModal,
    DealerWorkingHours,
    MicrophoneIcon,
    AssistantWithSpark,
    VoiceRecorder,
    Sparks

  },
  watch: {
    showChatData(newValue) {
      if (newValue) {
        this.startTypingEffect();
        this.prepareNextPrompt();
        // this.inputRef.focus();
      }
    },

  },
};
</script>


<style lang="less">
@import './AssistantAi.less';
</style>
